module.exports = __webpack_public_path__ + "pin_turquoise.6a959c.png";